var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{class:'m-alert m-alert--outline alert alert-' + _vm.type +' alert-dismissible',attrs:{"role":"alert"}},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close')}}}),_c('span',[_vm._v(_vm._s(_vm.msg))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }